import { T_Major } from "./ModulePropTypes";
import { PT_Org } from "./ModulePermitTypes";

export const _uploads = {
  id: "uploads",
  permitType: PT_Org,
  type: T_Major,
  modules: [],
};
